import React from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import ReportNav from "./report-nav";
import { useState } from "react";
// import axios from "axios";
import Service from "../webservice/http";
import { useEffect } from "react";
import MutualViewMore from "./mutualViewMore";

function Mutual() {
  const [open, setOpen] = useState(false);
  const [id, setid] = useState();
  const [data, setData] = useState();

  const services = new Service();
  function fetchData() {
    services.get("api/product/mutualfund_list/").then((res) => {
      // console.log(res);
      setData(res);
    });
  }
  useEffect(() => {
    fetchData();
  }, []);

  // console.log(data);

  return (
    <div>
      <Header />
      <NavBar />
      <div>
        <div className="container-fluid">
          <div className="my-call">
            <div
              className="side-panel-with-table clearfix"
              style={{ display: "flex" }}
            >
              <ReportNav />
              <div className="call-table">
                <div className="my-calls-column">
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i
                              className="fa fa-snowflake-o"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="pannel-heading-info">
                            <h3>Mutual Funds </h3>
                            <p>Details</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <table className="ss">
                  <thead>
                    <tr>
                      <th>
                        <p>Name</p>
                      </th>
                      <th>
                        <p>Folio Number</p>
                      </th>
                      <th>
                        <p>Company</p>
                      </th>

                      <th>
                        <p>Buy</p>
                      </th>

                      <th>
                        <p>Sell</p>
                      </th>
                      <th>
                        <p>Units</p>
                      </th>
                      <th>
                        <p>Date</p>
                      </th>
                      <th>
                        <p>Amount</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((e) => (
                      <tr
                        onClick={() => {
                          setid(e?.id);
                          setOpen(true);
                        }}
                      >
                        <td>
                          <p className="blue">{e?.name}</p>
                        </td>
                        <td>
                          <p>{e?.folio_number}</p>
                        </td>
                        <td>
                          <p className="blue">{e?.company_name}</p>
                        </td>
                        <td>
                          <p>{e?.buy ? "Buy" : "-"}</p>
                        </td>
                        <td>
                          <p>{e?.sell ? "Sell" : "-"}</p>
                        </td>
                        <td>
                          <p>{e?.units}</p>
                        </td>

                        <td
                          style={{ alignItems: "center", whiteSpace: "nowrap" }}
                        >
                          <p>{e?.date} </p>
                        </td>
                        <td style={{ alignItems: "center" }}>
                          <p>{e?.amount}</p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {open && <MutualViewMore orderId={id} setOpen={setOpen} />}
    </div>
  );
}

export default Mutual;
